export const clearSessionStoragePersonTypesAmounts = (): void => {
  sessionStorage.removeItem('chosenPersonTypes');
  sessionStorage.removeItem('chosenPartyMembersOnTicket');
  sessionStorage.setItem('ticketsStartDate', '');
  sessionStorage.setItem('ticketsEndDate', '');
  sessionStorage.setItem('discountTokenId', '');
};
